import { addValidator } from '@nelio/forms/validation';

addValidator( 'checkbox' );
